import React from "react";
import { AlertSign } from "@letsbit/milkylb";
import { FormattedMessage, useIntl } from "react-intl";

import { DepositMessagesProps } from "./types";
import { messages } from "./messages";
import { DepositFeeWarning } from "components/DepositFeeWarning";

import "./styles.scss";

export const DepositMessages: React.FC<DepositMessagesProps> = ({
  currency,
  currency_network,
}) => {
  const intl = useIntl();
  return (
    <div className="deposit-messages">
      <div className="gap-2">
        {/* shows general messages from currency */}
        {/* memo required */}
        {currency_network.payment_network.taggable && (
          <AlertSign text={intl.formatMessage(messages.memo)} />
        )}
        {/* shows min_deposit_amount admitted by currency_network */}
        {+currency_network.min_deposit_amount > 0 ? (
          <AlertSign
            text={
              <FormattedMessage
                {...messages.min_deposit_amount}
                values={{
                  min_deposit: `${currency_network.min_deposit_amount}`,
                  currency: currency.ticker_id.toUpperCase(),
                }}
              />
            }
            kind={"info"}
          />
        ) : null}
        {/* shows fee required by currency_network */}
        <DepositFeeWarning
          currency={currency}
          currency_network={currency_network}
        />
      </div>
    </div>
  );
};

export default DepositMessages;
